import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import { useState } from "react";
import { useDeleteSocialMediaPost } from "../api/deletePost";
import { LoadingButton } from "@mui/lab";

export default function DeletePost({
  children,
  postData,
  onSuccess = () => {},
}) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const deletePostMutation = useDeleteSocialMediaPost({
    postId: postData.postagemid,
    themeId: postData.temaid,
  });
  const openConfirmationDialog = () => {
    setDialogOpen(true);
  };
  const handleClose = () => {
    setDialogOpen(false);
  };

  const handleDeletePost = () => {
    deletePostMutation.mutate(
      {},
      {
        onSuccess: () => {
          handleClose();
          onSuccess();
        },
      }
    );
  };

  const methods = { openConfirmationDialog };
  return (
    <>
      <Dialog open={dialogOpen} onClose={handleClose}>
        <DialogContent>
          <DialogContentText>
            Essa ação é permanente e irreversível.
            <br />
            Vocẽ tem certeza que deseja excluir essa postagem?
          </DialogContentText>
          <DialogActions>
            <Button onClick={handleClose}>Cancelar</Button>
            <LoadingButton
              onClick={handleDeletePost}
              loading={deletePostMutation.loading}
              variant="contained"
            >
              Excluir
            </LoadingButton>
          </DialogActions>
        </DialogContent>
      </Dialog>
      {children(methods)}
    </>
  );
}
